import Stamp from '../../../../../types/api/stamp'
import { getAvailabilityFromOrder } from './common'
import { AvailabilityDisplay } from './types'

export function getStampAvailabilityStatus(stamp?: Stamp | null): AvailabilityDisplay {
    return getAvailabilityFromOrder(stamp?.last_order, {
        missing: 'Штамп не заказан',
        notOrderedInfo: 'Создана заявка на заказ',
    })
}
